module.exports = __webpack_public_path__ + "img/83.d5357eb9.png";